export const editWatchlist = async (userId, list, name, token) => {
    try {
        const res = await fetch('/api/watchlist/edit-watchlist', {
            method: 'POST',
            headers: { 'x-access-token': token },
            body: JSON.stringify({
                userId,
                list,
                name,
            }),
        });
        const response = await res.json();
        return response.data;
    } catch (error) {
        console.error(error);
    }
}